import _assign from "object-assign";
var iconWidth = 15;
var topYOrigin = {
  touch: 11,
  low: 7,
  medium: 5,
  high: 3
};
var labelYTranslation = {
  touch: 26,
  low: 23,
  medium: 20,
  high: 17
};
var regularTypeSizePaletteIndices = {
  touch: 70,
  low: 60,
  medium: 50,
  high: 40
};
var captionTypeSizePaletteIndices = {
  touch: 50,
  low: 40,
  medium: 40,
  high: 30
};
export var formLabelStyle = function formLabelStyle(_ref) {
  var toolkitTheme = _ref.toolkit;
  var getDisabled = toolkitTheme.disabled.getDisabled,
      _toolkitTheme$palette = toolkitTheme.palette,
      type = _toolkitTheme$palette.type,
      grey200 = _toolkitTheme$palette.grey200,
      grey70 = _toolkitTheme$palette.grey70,
      getSize = toolkitTheme.size.getSize,
      spacing = toolkitTheme.spacing,
      _toolkitTheme$statusN = toolkitTheme.statusNext,
      getStatus = _toolkitTheme$statusN.getStatus,
      statusStates = _toolkitTheme$statusN.statusStates,
      typography = toolkitTheme.typography;

  var createStatusIndicatorVariantStyle = function createStatusIndicatorVariantStyle(variant) {
    var _getStatus = getStatus(variant),
        variantColor = _getStatus.status;

    return {
      '&$statusIndicatorIconRoot': {
        color: variantColor
      }
    };
  };

  var createDensityStyle = function createDensityStyle(_ref2) {
    var density = _ref2.density;
    var spacingMixin = spacing[density].spacing;
    var formLabelMinHeight = getSize ? getSize({
      density: density
    }).height : undefined;
    var regularFontSize = typography.size[regularTypeSizePaletteIndices[density]];

    var regularTypography = _assign({
      letterSpacing: 0,
      lineHeight: typography.lineHeight,
      fontSize: regularFontSize,
      minHeight: typography.getMinHeight(regularFontSize)
    }, typography.getFace());

    var captionFontSize = typography.size[captionTypeSizePaletteIndices[density]];

    var captionTypography = _assign({
      letterSpacing: 0,
      lineHeight: typography.lineHeight,
      fontSize: captionFontSize,
      minHeight: typography.getMinHeight(captionFontSize)
    }, typography.getFace());

    return {
      paddingLeft: spacingMixin(1),
      paddingRight: spacingMixin(1),
      minHeight: formLabelMinHeight,
      '&$float': _assign({}, regularTypography, {
        minHeight: formLabelMinHeight,
        transform: "translate(0px, ".concat(labelYTranslation[density], "px)"),
        transition: 'transform 400ms cubic-bezier(0.0, 0, 0.2, 1) 0ms',
        '&$shrink': _assign({}, captionTypography, {
          transform: "translate(0px, ".concat(topYOrigin[density], "px)"),
          transition: 'transform 400ms cubic-bezier(0.0, 0, 0.2, 1) 0ms',
          paddingRight: spacingMixin(1)
        }),
        '&$hasStartAdornment': {
          paddingLeft: spacingMixin(2) + iconWidth,
          '&$shrink': {
            transform: "translate(".concat(-(spacingMixin(1) + iconWidth), "px, ").concat(topYOrigin[density], "px)")
          }
        },
        '&$hasEndAdornment': {
          paddingRight: spacingMixin(2) + iconWidth
        }
      }),
      '&$labelTop': _assign({}, captionTypography, {
        top: topYOrigin[density]
      }),
      '&$labelLeft': _assign({}, regularTypography, {
        paddingLeft: 0,
        paddingRight: spacingMixin(0.75),
        '& $statusIndicatorIconRoot': {
          marginLeft: density === 'high' ? '3px' : '6px'
        },
        '& $statusIndicatorTooltipRoot': {
          marginLeft: density === 'high' ? '3px' : '6px'
        }
      })
    };
  };

  var color = type === 'dark' ? grey70 : grey200;
  return {
    /* Styles applied to the root element */
    root: {
      boxSizing: 'border-box',
      width: '100%',
      color: color,
      '&.Mui-focused': {
        color: color
      },
      '&.Mui-disabled': {
        color: color
      },
      display: 'flex'
    },
    textContainer: {
      flexShrink: 1,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    },

    /* Styles applied to float the label */
    "float": {},

    /* Styles applied to the label when the related component has an end adornment */
    hasEndAdornment: {},

    /* Styles applied to the label when the related component has a start adornment */
    hasStartAdornment: {},

    /* Styles applied to shrink the label */
    shrink: {},

    /* Styles applied to place the label left */
    labelLeft: {
      position: 'static',
      width: 'auto'
    },

    /* Styles applied to the necessity indicator */
    necessityIndicator: {
      fontStyle: 'italic',
      marginLeft: '1ch'
    },

    /* Styles applied to the status indicator */
    statusIndicatorTooltipRoot: {
      marginLeft: '6px'
    },
    statusIndicatorIconRoot: {
      marginLeft: '6px',
      height: 13
    },
    statusIndicatorStateIconError: createStatusIndicatorVariantStyle(statusStates.error),
    statusIndicatorStateIconInfo: createStatusIndicatorVariantStyle(statusStates.info),
    statusIndicatorStateIconSuccess: createStatusIndicatorVariantStyle(statusStates.success),
    statusIndicatorStateIconWarning: createStatusIndicatorVariantStyle(statusStates.warning),
    statusIndicatorStateIconContainer: {
      flexShrink: 0
    },

    /* Styles applied to place the label top */
    labelTop: {},

    /* Styles applied to the root element if disabled */
    disabled: getDisabled(),

    /* Styles applied to the root element if read-only */
    readOnly: {},

    /* Styles applied to the root element if `density="touch"` */
    touchDensity: createDensityStyle({
      density: 'touch'
    }),

    /* Styles applied to the root element if `density="low"` */
    lowDensity: createDensityStyle({
      density: 'low'
    }),

    /* Styles applied to the root element if `density="medium"` */
    mediumDensity: createDensityStyle({
      density: 'medium'
    }),

    /* Styles applied to the root element if `density="high"` */
    highDensity: createDensityStyle({
      density: 'high'
    })
  };
};
//# sourceMappingURL=formLabelStyle.js.map